import { css } from "styled-components"


export const smallScreenPortrait = "600px"
export const smallScreen = "850px"
export const medScreen = "1400px"

export const smallScreenPortraitValue = 600
export const smallScreenValue = 850
export const medScreenValue = 1400

export const mobile = (props) => {
    return css`
        @media only screen and (max-width:${smallScreen}) {
            ${props}       
        }
    `
}

export const mobilePortrait = (props) => {
    return css`
    @media only screen and (max-width:${smallScreenPortrait}) {
        ${props}    
    }
    `
}

export const tablet = (props) => {
    return css`
        @media only screen and (max-width:${medScreen}) {
            ${props}       
        }
    `
}

export const tabletPortrait = (props) => {
    return css`
        @media only screen and (orientation: portrait) {
            ${props}
        }
    `
}